import * as React from "react";
import useGeneralMetricsSearch from "./hooks/useGeneralMetricsSearch";
import WelcomeSearch from "./WelcomeSearch";
const GeneralWelcomeMetrics = ({ topSourcesOnly = false }) => {
  const view = useGeneralMetricsSearch(topSourcesOnly);
  return /* @__PURE__ */ React.createElement(WelcomeSearch, { view });
};
export default GeneralWelcomeMetrics;
